/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  LoadoutSlotList,
  SchemaValidationErrorResponse,
  StandardError,
  VehicleLoadout,
  VehicleLoadoutInput,
  VehicleLoadoutsList
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create Vehicle Loadout
 */
export const createVehicleLoadout = (
    vehicleId: MaybeRefOrGetter<string>,
    vehicleLoadoutInput: MaybeRefOrGetter<VehicleLoadoutInput>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
vehicleLoadoutInput = toValue(vehicleLoadoutInput);

      return axiosClient<VehicleLoadout>(
      {url: `/vehicles/${vehicleId}/loadouts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: vehicleLoadoutInput, signal
    },
      );
    }




export const getCreateVehicleLoadoutMutationKey = () => ['createVehicleLoadout'] as const;

export const getCreateVehicleLoadoutMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVehicleLoadout>>, TError,CreateVehicleLoadoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVehicleLoadout>>, TError,CreateVehicleLoadoutMutationVariables, TContext> => {

const mutationKey = getCreateVehicleLoadoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVehicleLoadout>>, CreateVehicleLoadoutMutationVariables> = (props) => {
          const {vehicleId,data} = props ?? {};

          return  createVehicleLoadout(vehicleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVehicleLoadoutMutationResult = NonNullable<Awaited<ReturnType<typeof createVehicleLoadout>>>
    export type CreateVehicleLoadoutMutationBody = VehicleLoadoutInput
    export type CreateVehicleLoadoutMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateVehicleLoadoutMutationVariables = {vehicleId: string;data: VehicleLoadoutInput}

    /**
 * @summary Create Vehicle Loadout
 */
export const useCreateVehicleLoadout = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVehicleLoadout>>, TError,CreateVehicleLoadoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createVehicleLoadout>>,
        TError,
        CreateVehicleLoadoutMutationVariables,
        TContext
      > => {
      return useMutation(getCreateVehicleLoadoutMutationOptions(options), queryClient);
    }
    /**
 * @summary List Vehicle Loadouts
 */
export const vehicleLoadouts = (
    vehicleId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);

      return axiosClient<VehicleLoadoutsList>(
      {url: `/vehicles/${vehicleId}/loadouts`, method: 'GET', signal
    },
      );
    }




export const getVehicleLoadoutsQueryKey = (vehicleId: MaybeRefOrGetter<string>,) => {
    return [
    'vehicles',vehicleId,'loadouts'
    ] as const;
    }


export const getVehicleLoadoutsQueryOptions = <TData = Awaited<ReturnType<typeof vehicleLoadouts>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(vehicleId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleLoadouts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVehicleLoadoutsQueryKey(vehicleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vehicleLoadouts>>> = ({ signal }) => vehicleLoadouts(vehicleId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(vehicleId) !== null && toValue(vehicleId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vehicleLoadouts>>, TError, TData>
}

export type VehicleLoadoutsQueryResult = NonNullable<Awaited<ReturnType<typeof vehicleLoadouts>>>
export type VehicleLoadoutsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List Vehicle Loadouts
 */

export function useVehicleLoadouts<TData = Awaited<ReturnType<typeof vehicleLoadouts>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 vehicleId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleLoadouts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVehicleLoadoutsQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete Vehicle Loadout
 */
export const destroyVehicleLoadout = (
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
id = toValue(id);

      return axiosClient<VehicleLoadout>(
      {url: `/vehicles/${vehicleId}/loadouts/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyVehicleLoadoutMutationKey = () => ['destroyVehicleLoadout'] as const;

export const getDestroyVehicleLoadoutMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleLoadout>>, TError,DestroyVehicleLoadoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleLoadout>>, TError,DestroyVehicleLoadoutMutationVariables, TContext> => {

const mutationKey = getDestroyVehicleLoadoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyVehicleLoadout>>, DestroyVehicleLoadoutMutationVariables> = (props) => {
          const {vehicleId,id} = props ?? {};

          return  destroyVehicleLoadout(vehicleId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyVehicleLoadoutMutationResult = NonNullable<Awaited<ReturnType<typeof destroyVehicleLoadout>>>

    export type DestroyVehicleLoadoutMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyVehicleLoadoutMutationVariables = {vehicleId: string;id: string}

    /**
 * @summary Delete Vehicle Loadout
 */
export const useDestroyVehicleLoadout = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleLoadout>>, TError,DestroyVehicleLoadoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyVehicleLoadout>>,
        TError,
        DestroyVehicleLoadoutMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyVehicleLoadoutMutationOptions(options), queryClient);
    }
    /**
 * @summary Show Vehicle Loadout
 */
export const vehicleLoadout = (
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
id = toValue(id);

      return axiosClient<VehicleLoadout>(
      {url: `/vehicles/${vehicleId}/loadouts/${id}`, method: 'GET', signal
    },
      );
    }




export const getVehicleLoadoutQueryKey = (vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,) => {
    return [
    'vehicles',vehicleId,'loadouts',id
    ] as const;
    }


export const getVehicleLoadoutQueryOptions = <TData = Awaited<ReturnType<typeof vehicleLoadout>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleLoadout>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVehicleLoadoutQueryKey(vehicleId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vehicleLoadout>>> = ({ signal }) => vehicleLoadout(vehicleId,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(vehicleId) !== null && toValue(vehicleId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vehicleLoadout>>, TError, TData>
}

export type VehicleLoadoutQueryResult = NonNullable<Awaited<ReturnType<typeof vehicleLoadout>>>
export type VehicleLoadoutQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show Vehicle Loadout
 */

export function useVehicleLoadout<TData = Awaited<ReturnType<typeof vehicleLoadout>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleLoadout>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVehicleLoadoutQueryOptions(vehicleId,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Vehicle Loadout
 */
export const updateVehicleLoadout = (
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    vehicleLoadoutInput: MaybeRefOrGetter<VehicleLoadoutInput>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
id = toValue(id);
vehicleLoadoutInput = toValue(vehicleLoadoutInput);

      return axiosClient<VehicleLoadout>(
      {url: `/vehicles/${vehicleId}/loadouts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: vehicleLoadoutInput, signal
    },
      );
    }




export const getUpdateVehicleLoadoutMutationKey = () => ['updateVehicleLoadout'] as const;

export const getUpdateVehicleLoadoutMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicleLoadout>>, TError,UpdateVehicleLoadoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVehicleLoadout>>, TError,UpdateVehicleLoadoutMutationVariables, TContext> => {

const mutationKey = getUpdateVehicleLoadoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVehicleLoadout>>, UpdateVehicleLoadoutMutationVariables> = (props) => {
          const {vehicleId,id,data} = props ?? {};

          return  updateVehicleLoadout(vehicleId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVehicleLoadoutMutationResult = NonNullable<Awaited<ReturnType<typeof updateVehicleLoadout>>>
    export type UpdateVehicleLoadoutMutationBody = VehicleLoadoutInput
    export type UpdateVehicleLoadoutMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateVehicleLoadoutMutationVariables = {vehicleId: string;id: string;data: VehicleLoadoutInput}

    /**
 * @summary Update Vehicle Loadout
 */
export const useUpdateVehicleLoadout = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicleLoadout>>, TError,UpdateVehicleLoadoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateVehicleLoadout>>,
        TError,
        UpdateVehicleLoadoutMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateVehicleLoadoutMutationOptions(options), queryClient);
    }
    /**
 * @summary Activate Vehicle Loadout
 */
export const activateVehicleLoadout = (
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
id = toValue(id);

      return axiosClient<VehicleLoadout>(
      {url: `/vehicles/${vehicleId}/loadouts/${id}/activate`, method: 'PUT', signal
    },
      );
    }




export const getActivateVehicleLoadoutMutationKey = () => ['activateVehicleLoadout'] as const;

export const getActivateVehicleLoadoutMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateVehicleLoadout>>, TError,ActivateVehicleLoadoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activateVehicleLoadout>>, TError,ActivateVehicleLoadoutMutationVariables, TContext> => {

const mutationKey = getActivateVehicleLoadoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateVehicleLoadout>>, ActivateVehicleLoadoutMutationVariables> = (props) => {
          const {vehicleId,id} = props ?? {};

          return  activateVehicleLoadout(vehicleId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateVehicleLoadoutMutationResult = NonNullable<Awaited<ReturnType<typeof activateVehicleLoadout>>>

    export type ActivateVehicleLoadoutMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ActivateVehicleLoadoutMutationVariables = {vehicleId: string;id: string}

    /**
 * @summary Activate Vehicle Loadout
 */
export const useActivateVehicleLoadout = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateVehicleLoadout>>, TError,ActivateVehicleLoadoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof activateVehicleLoadout>>,
        TError,
        ActivateVehicleLoadoutMutationVariables,
        TContext
      > => {
      return useMutation(getActivateVehicleLoadoutMutationOptions(options), queryClient);
    }
    /**
 * @summary Vehicle Loadout Slots
 */
export const vehicleLoadoutSlots = (
    vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
id = toValue(id);

      return axiosClient<LoadoutSlotList>(
      {url: `/vehicles/${vehicleId}/loadouts/${id}/slots`, method: 'GET', signal
    },
      );
    }




export const getVehicleLoadoutSlotsQueryKey = (vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,) => {
    return [
    'vehicles',vehicleId,'loadouts',id,'slots'
    ] as const;
    }


export const getVehicleLoadoutSlotsQueryOptions = <TData = Awaited<ReturnType<typeof vehicleLoadoutSlots>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleLoadoutSlots>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVehicleLoadoutSlotsQueryKey(vehicleId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vehicleLoadoutSlots>>> = ({ signal }) => vehicleLoadoutSlots(vehicleId,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(vehicleId) !== null && toValue(vehicleId) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vehicleLoadoutSlots>>, TError, TData>
}

export type VehicleLoadoutSlotsQueryResult = NonNullable<Awaited<ReturnType<typeof vehicleLoadoutSlots>>>
export type VehicleLoadoutSlotsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Vehicle Loadout Slots
 */

export function useVehicleLoadoutSlots<TData = Awaited<ReturnType<typeof vehicleLoadoutSlots>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 vehicleId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleLoadoutSlots>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVehicleLoadoutSlotsQueryOptions(vehicleId,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






